/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ScopeEnum {
    REGISTERED = 'REGISTERED',
    MANAGER = 'MANAGER',
    ADMIN = 'ADMIN',
    BLOGGER = 'BLOGGER',
    MODERATOR = 'MODERATOR',
    INSIDER_PLUS = 'INSIDER_PLUS',
}
